'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'umbrella-beach';
var width = 512;
var height = 512;
var aliases = [127958];
var unicode = 'f5ca';
var svgPathData = 'M27 141.5l215.5 107.7-123.4 246.8-119.1 0 0 16 512 0 0-16-375.1 0 119.8-239.6 228.3 114.1c2.4-4.8 4.6-9.6 6.7-14.5 13-30.7 20.3-64.5 20.3-100 0-141.4-114.6-256-256-256-94.5 0-177.1 51.2-221.4 127.4-2.7 4.6-5.2 9.3-7.6 14.1zM496 256c0 32.9-6.6 64.3-18.6 92.8L48.9 134.6C90.6 63.6 167.8 16 256 16 388.5 16 496 123.5 496 256z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUmbrellaBeach = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;